import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { isMobileWidth, isTabletWidth } from '../../util/util'

const getProductBoxWidth = (breakpoint: number): string => {
  if (breakpoint >= 1200) {
    return '30%'
  }
  if (breakpoint < 640) {
    return '100%'
  }
  if (breakpoint < 1200) {
    return '45%'
  }
  return '45%'
}

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  const productBoxWidth = getProductBoxWidth(breakpoint)
  return {
    content: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      minHeight: '90vh',
      flexWrap: 'wrap',
      height: '100%',
      paddingHorizontal: responsivePadding,
      backgroundColor: 'white',
    } as ViewStyle,
    buttonBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
    } as ViewStyle,
    productContainer: {
      // // flexDirection: 'row',
      // justifyContent: isTab ? 'space-between' : 'flex-start',
      // alignItems: 'center',
      // flexWrap: 'wrap',
      // paddingHorizontal: responsivePadding,
      marginTop: isTab ? 5 : isMobile ? 20 : 80,
      // alignSelf: 'flex-start',
    } as BoxProps,
    productLayout: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    } as BoxProps,
    productBox: {
      minWidth: 260,
      minHeight: 240,
      width: productBoxWidth,
      padding: 40,
      shadowOffset: { width: 2, height: 2 },
      shadowRadius: 3,
      shadowColor: 'LIGHT_GREY',
      borderRadius: 20,
      margin: isMobile ? 0 : 16,
      marginBottom: isMobile ? 16 : 16,
      justifyContent: 'center',
      elevation: 1,
    } as ViewStyle,
    ImageKeyborad: {
      width: 24,
      height: 24,
      marginTop: 5,
    } as ViewStyle,
    merchantPartner: {
      justify: 'center',
    } as BoxProps,
    dimRightArrow: {
      width: 20,
      height: 20,
      opacity: 0.2,
      marginTop: 3,
    } as ViewStyle,
    imageSize: {
      height: 56,
      width: 56,
    } as ViewStyle,
    rowCon: {
      flexDirection: 'row',
      alignItems: 'center',
    } as BoxProps,
    textContainer: (resPadding: number) =>
      ({
        pl: isTab ? 65 : isMobile ? 40 : 150,
      } as BoxProps),
  }
}
